import React from "react";
import PropTypes from "prop-types";
import { FormGroup, FormControl, ControlLabel, Row, Col, Pager} from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from "react-select";
import InlineError from "../../../messages/InlineError";

class SalaryFields extends React.Component {
	render() {
		return(
			<React.Fragment>
				<FormGroup className={`salary-fields ${this.props.errors.salary_error && "error"}`}>
					{this.props.formData.salaries.map((salary, index)=>(
						<Row key={salary.id}>
							<Col md={4}>
								<FormGroup>
									<ControlLabel>Salary</ControlLabel>
									<FormControl type="number" 
										name={`salary-${salary.id}`} 
										placeholder="Enter salary" 
										value={salary.domestic_salary || ""} 
										onChange={(e)=>this.props.onChangeSalaryValue(e, salary)}
									/>	
								</FormGroup>
							</Col>
							<Col md={4}>
								<FormGroup validationState={this.props.errors.currency && "error"}>
									<ControlLabel>Currency</ControlLabel>
									<Select
										onChange={(option) => { this.props.onChangeSalaryCurrency(option, salary); }}
										name="currency"
										placeholder="Choose currency"
										value={salary.currency || ""}
										options={this.props.currencies}
										isLoading={this.props.isLoadingCurrencies}
										clearable={false}
										multi={false}
									/>
									{this.props.errors.currency && <InlineError text={this.props.errors.currency} />}
								</FormGroup>
							</Col>
							<Col md={4}>
								<FormGroup>
									<ControlLabel>Salary start date</ControlLabel>
									<DatePicker
										selected={salary.selectedFromDate ? moment(salary.selectedFromDate) : null}
										onChange={(date)=>this.props.onFromDateChange(date, salary)}
										dateFormat="DD-MM-YYYY"
										className="form-control"
										placeholderText="Choose date"
									/>
								</FormGroup>
							</Col>						
						</Row>
					))}
					<button onClick={this.props.addNewSalary} className="btn btn-default btn-crud" type="button">Add new salary</button> 
					{this.props.errors.salary_error && <div className="alert" role="alert">{this.props.errors.salary_error}</div>}
				</FormGroup>
			</React.Fragment>
		);
	}
};

SalaryFields.defaultProps = {
	errors: PropTypes.object,
	onChangeSalaryValue: PropTypes.func,
	onChangeSalaryCurrency: PropTypes.func,
	addNewSalary: PropTypes.func,
	onFromDateChange: PropTypes.func,
	onWorkDateChange: PropTypes.func,
	user_id: null,
	selectedStartDate: null,
	selectedEndDate: null,
	isLoadingCurrencies: false,
	currencies: [],
};

SalaryFields.propTypes = {
	isLoadingCurrencies: PropTypes.bool,
	formData: PropTypes.shape({
		domestic_salary: PropTypes.string,
		currency: PropTypes.string,
		receives_log_emails: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.number
		]),
		salaries: PropTypes.arrayOf(
			PropTypes.object
		),
	}).isRequired,
	errors: PropTypes.shape({
		salary_error: PropTypes.string,
		currency: PropTypes.string,
		domestic_salary: PropTypes.string,
	}),
	currencies: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	onChangeSalaryValue: PropTypes.func,
	onChangeSalaryCurrency: PropTypes.func,
	onFromDateChange: PropTypes.func,
	addNewSalary: PropTypes.func,
	
};

export default SalaryFields;


// WEBPACK FOOTER //
// ./src/components/forms/users/fields/SalaryFields.js